import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import { createStore } from "redux";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import conversationReducer from "./redux/reducers/conversationReducer";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost =
  process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

const isProductionLike = process.env.NODE_ENV === "production";

if (posthogKey && isProductionLike) {
  console.log("[PostHog] Initializing client", { posthogHost });
  posthog.init(posthogKey, {
    api_host: posthogHost,
    capture_pageview: true,
    autocapture: true,
    capture_pageleave: true,
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: false,
    },
  });

  if (typeof posthog.startSessionRecording === "function") {
    console.log("[PostHog] Starting session recording");
    posthog.startSessionRecording();
  } else {
    console.log("[PostHog] Session recording API unavailable on client");
  }
} else {
  console.log("[PostHog] Analytics disabled in this environment", {
    hasKey: Boolean(posthogKey),
    nodeEnv: process.env.NODE_ENV,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const store = createStore(conversationReducer);

const appTree = (
  <BrowserRouter>
    <ToastContainer />
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
);

if (posthogKey && isProductionLike) {
  console.log("[PostHog] Rendering app with provider");
  root.render(<PostHogProvider client={posthog}>{appTree}</PostHogProvider>);
} else {
  console.log("[PostHog] Rendering app without PostHog");
  root.render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
